import mod from "-!../../../../node_modules/babel-loader/lib/index.js??ref--4-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResultPeriodical.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--4-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResultPeriodical.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/service/ResultPeriodical.vue?vue&type=script&lang=js&
// module id = null
// module chunks = 